import {
    BaseTable,
    Card,
    Loading,
    Button,
    Select,
    HeaderMenu,
    FooterMenu,
    CommandButton
} from "components"
import { useEffect, useState } from "react"
import { PaginationState } from "types"
import { FilterFormTypes } from "./types/ProjectTypes"
import moment from "moment"
import { useProjectList } from "./utils/useProjectList"
import { APPROVE_STATUS, 
        APPROVE_STATUS_OPTIONS, 
        getApprovalStatusLabel,
        getProjectTypeLabel,
        getProjectStatusLabel
} from "pages/Project/utils/projectTypeOption"
import { convertNumber } from "utils"
import { ApproveAction } from "./components/ApproveAction"
import { useNavigate } from "react-router-dom"

export function ListApproveProject(): JSX.Element {

    const [filter, setFilter] = useState<FilterFormTypes>({
        approve_status: '1',
    })

    const default_pagination_value = {
        total: 0,
        page: 1,
        limit: 10,
        pages: 1,
        keyword: "",
    }

    const [pagination] = useState<PaginationState>(
        default_pagination_value
    )

    const { data, isLoading, refetch } = useProjectList({
        approve_status : filter.approve_status,
    })

    useEffect(() => {
        refetch()
        //eslint-disable-next-line
    }, [pagination.page, pagination.limit])

    const handleClick = () =>{
        refetch()
    } 

    const navigate = useNavigate()
    let rowNumber = 1;

    return (
        <><section className="m-5">
            <HeaderMenu title="APPROVAL PROJECT" />

            <section>
            <Card>
                <Card.Body>
                    <section className="lg:flex overflow-x-auto">
                        <div className="flex w-full"> 
                            <div className="flex items-center w-[284px] lg:w-[250px] mx-2">
                                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">
                                    STATUS
                                    </div>
                                    <Select
                                        value={
                                            APPROVE_STATUS_OPTIONS.find(
                                                (opt) => opt.value?.toString() === filter.approve_status?.toString()
                                            ) || APPROVE_STATUS_OPTIONS[0] // default ALL
                                        }
                                        options={APPROVE_STATUS_OPTIONS}
                                        onChange={(e) => {
                                            setFilter({
                                                ...filter,
                                                approve_status: e?.value ?? APPROVE_STATUS.PENDING,
                                            })
                                        }}
                                    />
                            </div>

                            <div className="flex">
                                <Button className="bg-primary"
                                    onClick={handleClick}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </section>
                </Card.Body>
            </Card>
            </section>

            <section>
                <Card>
                    <Card.Body>
                    <div className="overflow-x-auto max-h-[calc(100vh-570px)]">
                        <BaseTable>
                        <thead className="top-0 z-1 !bg-black !text-white">
                            <tr>
                                <th>NO</th>
                                <th colSpan={2}>ID#</th>
                                <th>PROJECT NAME</th>
                                <th>DATE</th>
                                <th>TYPE OF PROJECT</th>
                                <th>MANAGER</th>
                                <th>CONTACT</th>
                                <th>DEPARTMENT</th>
                                <th>STATUS</th>
                                <th>BUDGET ALLOCATION</th>
                                <th>STATUS APPROVE</th>
                                <th>DATE APPROVE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading || data?.length === 0 ? (
                            <tr>
                                <td colSpan={13}>
                                <Loading
                                    loading={isLoading}
                                    errorText="No data available"
                                />
                                </td>
                            </tr>
                            ) : (
                                data.map((item,index) => {

                                    return(
                                        <tr key={index}>
                                            <td>
                                                {rowNumber++}
                                            </td>
                                            <td>
                                                <ApproveAction data={item} refetch={refetch} />
                                            </td>
                                            <td className="text-center">{item.trx_code}</td>
                                            <td>{item.project_name}</td>
                                            <td className="text-center">{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                            <td className="text-center">{getProjectTypeLabel(String(item.type_project)) ?? "-"}</td>
                                            <td>{item.employee_name}</td>
                                            <td>{item.contact}</td>
                                            <td>{item.department_name}</td>
                                            <td>{getProjectStatusLabel(String(item.status_project)) ?? "-"}</td>
                                            <td className="text-right">{convertNumber(Number(item.budget_allocation ?? 0)).intoCurrency}</td>
                                            <td>{getApprovalStatusLabel(String(item.approve_status)) ?? "-"}</td>
                                            <td className="text-center">{item.approve_date !== null ? moment(item.approve_date).format('DD/MM/YYYY') : ''}</td>
                                        </tr>
                                    )
                                })
                            )}

                        </tbody>
                        </BaseTable>
                        <div className="mt-3">
                        {/* <PaginationData
                            data={data}
                            pagination={pagination}
                            setPagination={setPagination}
                        /> */}
                        </div>
                    </div>
                    </Card.Body>
                </Card>
            </section>
        </section>

        <FooterMenu
            customRightElement={
                <CommandButton
                    type="button"
                    actiontype="cancel"
                    onClick={() => navigate(-1)}
                />
            }
            customElement={{ journal: <></>, print: <></> }}
        />
        </>
    )
}
